export default __webpack_public_path__ + "static/media/ens.c48c41c3.png";